module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-pants.54514d70.png";